export default __webpack_public_path__ + "../img/efbafc5d3c55e87d366abd647eef0551.png";